<template>
	<div id="player-header">
		<h1>{{ title }}</h1>
		<p>Artist:
			<ScoreArtist 
				:artist="artist"
				:artistURL="artistURL">
			</ScoreArtist>
		</p>
		<div v-for="(difficult, index) in difficulties" :key="index">
			<p>{{ difficult['diff-name'] }} : ★&times;{{ difficult['diff-level'] }}</p>
		</div>
	</div>
</template>

<script>
import ScoreArtist from "./ScoreArtist.vue";

export default {
	components: {
		ScoreArtist: ScoreArtist,
	},
	props: {
		title: {
			type: String,
			required: true,
		}, 
		artist: {
			type: String,
			required: true,
		}, 
		artistURL: {
			type: String,
		}, 
		difficulties: {
			type: Array,
			required: true,
		}, 
	},
}
</script>

<style scoped>
	#player-header {
		padding: 16px;
		text-align: center;
		/* background-color: #384a5a; */
	}
</style>